import React from "react";
import { DateRangeChartProps } from "../types";
import { DateRangeChartComponent } from "../components";
import { getEmissionType } from "../utils";

export const EstimatesChart = ({
  dateRangeType,
  subTabName,
  currentMainTab,
  ...props
}: DateRangeChartProps) => {
  const generateChartData = (data: any[], emissionType: string) => {
    const estimateType = getEmissionType(
      subTabName === "location" || subTabName === "market",
      currentMainTab === "Consumption",
      subTabName,
      true,
    );
    // Create two separate data arrays for estimates and bills
    const estimatesData = data.map((entry: any) => ({
      ...entry,
      [estimateType]: entry[`${estimateType}Estimate`] ?? 0,
    }));
    const billsData = data.map((entry: any) => ({
      ...entry,
      [emissionType]: entry[emissionType] ?? 0,
    }));
    return {
      Estimates: estimatesData,
      Bills: billsData,
    };
  };

  const generateSeriesData = (chartData: any, sortedCategories: string[]) => {
    const estimateType = getEmissionType(
      subTabName === "location" || subTabName === "market",
      currentMainTab === "Consumption",
      subTabName,
      true,
    );
    const emissionType = getEmissionType(
      subTabName === "location" || subTabName === "market",
      currentMainTab === "Consumption",
      subTabName,
    );
    // Process estimates data
    const estimatesArr = sortedCategories.map((entry: string) => {
      const value =
        chartData.Estimates.find((item: any) => {
          if (dateRangeType === "MONTHLY") {
            return `${item.month} '${item.year?.substring(2, 4)}` === entry;
          }
          if (dateRangeType === "QUARTERLY") {
            return (
              item.fiscalYearQuarter === entry?.substring(1, 2) &&
              item.fiscalYear?.substring(2) === entry?.substring(4, 6)
            );
          }
          return item.fiscalYear === entry?.substring(0, 4);
        })?.[estimateType] ?? 0;
      return value;
    });
    // Process bills data
    const billsArr = sortedCategories.map((entry: string) => {
      const value =
        chartData.Bills.find((item: any) => {
          if (dateRangeType === "MONTHLY") {
            return `${item.month} '${item.year?.substring(2, 4)}` === entry;
          }
          if (dateRangeType === "QUARTERLY") {
            return (
              item.fiscalYearQuarter === entry?.substring(1, 2) &&
              item.fiscalYear?.substring(2) === entry?.substring(4, 6)
            );
          }
          return item.fiscalYear === entry?.substring(0, 4);
        })?.[emissionType] ?? 0;
      return value;
    });
    return {
      Estimates: estimatesArr,
      Bills: billsArr,
    };
  };

  return (
    <DateRangeChartComponent
      {...props}
      dateRangeType={dateRangeType}
      subTabName={subTabName}
      currentMainTab={currentMainTab}
      chartType="estimate"
      dataKey="estimate"
      generateChartData={generateChartData}
      generateSeriesData={generateSeriesData}
    />
  );
};
